import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid'
import {
    Translation
} from '../../features/translations/getTranslation'

const useStyles = makeStyles((theme) => ({
    typography: {
        padding: theme.spacing(2),
        color: '#fff',
        backgroundColor: "#1CABE2"
    },
}));

export default function QuestionPopover(props: any) {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event: any) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    return (
        <Grid container justifyContent="flex-end">
            <div aria-describedby={id} onClick={handleClick} style={{ fontSize: "16px", color: '#F26A21' }}>
                <i className="far fa-question-circle" />
            </div>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                transformOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
                <Typography className={classes.typography}>{Translation.t(props.text)}</Typography>
            </Popover>
        </Grid>
    );
}
